import React, { useState, useEffect } from "react";
import PropTypes from "prop-types"; // Import PropTypes
import Modal from "react-bootstrap/Modal";
import axios from "../api/axios";
import { Apitoken, Authtoken, role_id, user_location } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const AddContractPo = ({ contract, handleClose, show }) => {

  const [backendSuccess, setBackendSuccess] = useState(null);
  const [backendErrors, setBackendErrors] = useState({});

  const [locationLoading, setLocationLoading] = useState([]);

  const [shippingAddress, setShippingAddress] = useState([]);
  const [qtyprice, setQtyprice] = useState('');


  console.log(contract);

  const [formData, setFormData] = useState({
    contract: contract,
    po_number: "",
    shipping_address: '',
    processing_line: "",
    quantity: "",
    price: qtyprice,
    loading_type: "",
    lot_number: "",
    status: "",
    shipping_method: "",

  });
  useEffect(() => {
    if (contract) {
      setFormData(prev => ({ ...prev, contract }));
    }
  }, [contract]);

  useEffect(() => {
    if (contract && contract !== null) {

      axios.get(`/contracts/edit/${contract}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      }).then((response) => {
        if (response.data.code === 200) {
          const price = response.data.data.contract.price;
          setQtyprice(price); // still keep this if you use it elsewhere
          setFormData((prevFormData) => ({
            ...prevFormData,
            price: price
          }));
        }
      }).catch((error) => {
        console.log(error);
      });


      axios.post(`/contracts/addresses/listing/${contract}`, {}, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      }).then((response) => {
        if (response.data.code === 200) {
          let addresslist = response.data.data.address;
          let addresses = addresslist.map((customer, index) => ({
            label: customer.name,
            value: customer.id,
            key: `address-${index}`,
          }));

          setShippingAddress(addresses);
        }
      })
        .catch((error) => {
          console.log(error);
        });




    }

    axios.get(`/helpers/loading-locations-new`, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken, },
    }).then((response) => {
      if (response.data.code === 200) {
        let locations = response.data.data.locations;
        let locationslist = locations.map((ord, index) => ({
          label: ord.title,
          value: ord.id,
          key: `product-${index}`,
        }));
        if (role_id == 0) {

          const filteredData = locationslist.filter(item => item.value == user_location);
          console.log('filteredData');
          console.log(filteredData);
          setLocationLoading(filteredData);

          setFormData((prevFormData) => ({
            ...prevFormData,
            processing_line: user_location
          }));
        } else {
          setLocationLoading(locationslist);
          setFormData((prevFormData) => ({
            ...prevFormData,
            processing_line: user_location
          }));
        }

      } else {
        console.log("API response is not an array");
      }
    })
      .catch((error) => {
        console.log(error);
      });







  }, [contract]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setBackendErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[name];
      return updatedErrors;
    });
  };



  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post("/contracts/orders/add", formData, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setBackendSuccess(response.data.message);
          toast.success(response.data.message);
          setTimeout(() => {
            window.location.href = "/contracts-view/" + contract;
          }, 500);
        } else {
          setBackendErrors(response.data.error || {});
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const customHandleInput = (event) => {
    const inputName = event.target.name;
    setBackendErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors[inputName];
      return newErrors;
    });
  };

  return (
    <>
      <Modal centered show={show} onHide={handleClose} size="lg">
        <Modal.Header>
          <h4 className="modal-title">Add PO</h4>
          <button
            type="button"
            className="close"
            data-bs-dismiss="modal"
            onClick={handleClose}
            aria-hidden="true"
          >
            &times;
          </button>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit}> <ToastContainer />
            {backendSuccess && (
              <div className="from-success mt-1">{backendSuccess}</div>
            )}
            <div className="row">
              <div className="col-md-6">
                <div className="form-group" style={{ paddingTop: '10px' }}>
                  <label style={{ marginBottom: '0px' }}>PO Number</label>
                  <input
                    className="form-control form-white"
                    type="text"
                    name="po_number"
                    value={formData.po_number}
                    onChange={(e) => {
                      handleChange(e);
                      customHandleInput(e);
                    }}

                  />
                  {backendErrors.po_number && (
                    <small className="form-error mt-1">{backendErrors.po_number}</small>
                  )}
                </div>

              </div>


              <div className="col-md-6">
                <div className="form-group" style={{ paddingTop: '10px' }}>
                  <label style={{ marginBottom: '0px' }}>Select Shipping Address</label>
                  <select
                    className="form-control form-white"
                    name="shipping_address"
                    value={formData.shipping_address}
                    onChange={(e) => {
                      handleChange(e);
                      customHandleInput(e);
                      // customOperationInput(e);
                    }}
                  >
                    <option value="">Select</option>
                    {shippingAddress.map((type) => (
                      <option key={type.value} value={type.value}>
                        {type.label}
                      </option>
                    ))}
                  </select>
                  {backendErrors.shipping_address && (
                    <small className="form-error mt-1">{backendErrors.shipping_address}</small>
                  )}
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group" style={{ paddingTop: '10px' }}>
                  <label style={{ marginBottom: '0px' }}>Select Processing Line</label>
                  <select
                    className="form-control form-white"
                    name="processing_line"
                    value={formData.processing_line}
                    onChange={(e) => {
                      handleChange(e);
                      customHandleInput(e);
                      // customOperationInput(e);
                    }}
                  >
                    <option value="">Select</option>
                    {locationLoading.map((type) => (
                      <option key={type.value} value={type.value}>
                        {type.label}
                      </option>
                    ))}
                  </select>
                  {backendErrors.processing_line && (
                    <small className="form-error mt-1">{backendErrors.processing_line}</small>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group" style={{ paddingTop: '10px' }}>
                  <label style={{ marginBottom: '0px' }}>Quantity</label>
                  <input
                    className="form-control form-white"
                    type="text"
                    name="quantity"
                    value={formData.quantity}
                    onChange={(e) => {
                      handleChange(e);
                      customHandleInput(e);
                    }}
                    onKeyPress={(event) => {
                      if (!/^[0-9.]$/.test(event.key) || (event.key === "." && event.target.value.includes("."))) {
                        event.preventDefault();
                      }
                    }}
                  />
                  {backendErrors.quantity && (
                    <small className="form-error mt-1">{backendErrors.quantity}</small>
                  )}
                </div>

              </div>
              <div className="col-md-6">
                <div className="form-group" style={{ paddingTop: '10px' }}>
                  <label style={{ marginBottom: '0px' }}>Price</label>
                  <input
                    className="form-control form-white"
                    type="text"
                    name="price"
                    value={formData.price}
                    onChange={(e) => {
                      handleChange(e);
                      customHandleInput(e);
                    }}
                    onKeyPress={(event) => {
                      if (!/^[0-9.]$/.test(event.key) || (event.key === "." && event.target.value.includes("."))) {
                        event.preventDefault();
                      }
                    }}
                  />
                  {backendErrors.price && (
                    <small className="form-error mt-1">{backendErrors.price}</small>
                  )}
                </div>

              </div>


              <div className="col-md-6">
                <div className="form-group" style={{ paddingTop: '10px' }}>
                  <label style={{ marginBottom: '0px' }}>Select Loading Type</label>
                  <select
                    className="form-control form-white"
                    name="loading_type"
                    value={formData.loading_type}
                    onChange={(e) => {
                      handleChange(e);
                      customHandleInput(e);
                      // customOperationInput(e);
                    }}
                  >
                    <option value="">Select</option>
                    <option value="1">Floor Loaded</option>
                    <option value="2">Pallets Loaded</option>
                  </select>
                  {backendErrors.loading_type && (
                    <small className="form-error mt-1">{backendErrors.loading_type}</small>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group" style={{ paddingTop: '10px' }}>
                  <label style={{ marginBottom: '0px' }}>Lot Number</label>
                  <input
                    className="form-control form-white"
                    type="text"
                    name="lot_number"
                    value={formData.lot_number}
                    onChange={(e) => {
                      handleChange(e);
                      customHandleInput(e);
                    }}

                  />
                  {backendErrors.lot_number && (
                    <small className="form-error mt-1">{backendErrors.lot_number}</small>
                  )}
                </div>

              </div>
              <div className="col-md-6">
                <div className="form-group" style={{ paddingTop: '10px' }}>
                  <label style={{ marginBottom: '0px' }}>Select Order Status</label>
                  <select
                    className="form-control form-white"
                    name="status"
                    value={formData.status}
                    onChange={(e) => {
                      handleChange(e);
                      customHandleInput(e);
                      // customOperationInput(e);
                    }}
                  >
                    <option value="">Select</option>
                    <option value="1">Confirmed</option>
                    <option value="2">Finished</option>
                    <option value="3">In Process</option>
                    <option value="4">Draft</option>
                    <option value="5">Cancelled</option>
                    <option value="6">Shipped</option>
                    <option value="7">Delivered</option>
                  </select>
                  {backendErrors.status && (
                    <small className="form-error mt-1">{backendErrors.status}</small>
                  )}
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group" style={{ paddingTop: '10px' }}>
                  <label style={{ marginBottom: '0px' }}>Select Shipping method</label>
                  <select
                    className="form-control form-white"
                    name="shipping_method"
                    value={formData.shipping_method}
                    onChange={(e) => {
                      handleChange(e);
                      customHandleInput(e);
                      // customOperationInput(e);
                    }}
                  >
                    <option value="">Select</option>
                    <option value="Truck">Truck</option>
                    <option value="Container">Container</option>
                    <option value="EXW">EXW</option>
                  </select>
                  {backendErrors.shipping_method && (
                    <small className="form-error mt-1">{backendErrors.shipping_method}</small>
                  )}
                </div>
              </div>


            </div>

            <div className="submit-section">
              <button type="submit" className="btn btn-primary submit-btn">
                SUBMIT
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

// **Prop Type Validation**
AddContractPo.propTypes = {
  contract: PropTypes.any.isRequired, // If contract is an object, use PropTypes.object
  handleClose: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

export default AddContractPo;
